const IconDragHandle = (props) => {
  return (
    <svg
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8.5H37M3 15.5H37"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconDragHandle
